import { ThemeProps } from '@kijiji/theme'
import { FC, HTMLAttributes } from 'react'

import { StyledAs } from '@/ui/typings/helpers'

import { HeadlineTextBase } from './styled'

export type HeadlineTextProps = {
  /**
   * The type of element you want text to be rendered in
   * @default 'h1'
   */
  as?: StyledAs
  /**
   * Defined weight of text
   * @default 'medium'
   */
  weight?: keyof ThemeProps['fontWeight']
  /**
   * Define custom heading color
   */
  color?: string
  /**
   * Define heading size within typography theme
   * @default 'small'
   */
  size?: keyof ThemeProps['typography']['headline']
  /**
   * Defined alignment of heading
   */
  textAlign?: 'start' | 'end' | 'left' | 'center' | 'right' | 'justify'
} & HTMLAttributes<HTMLHeadingElement>

export const HeadlineText: FC<HeadlineTextProps> = ({
  color = 'initial',
  size = 'small',
  textAlign = 'start',
  weight = 'medium',
  ...rest
}: HeadlineTextProps) => {
  return (
    <HeadlineTextBase
      $color={color}
      $weight={weight}
      $size={size}
      $textAlign={textAlign}
      {...rest}
    />
  )
}
